import { render, staticRenderFns } from "./assist_person.vue?vue&type=template&id=1f8d4d80&scoped=true"
import script from "./assist_person.vue?vue&type=script&lang=js"
export * from "./assist_person.vue?vue&type=script&lang=js"
import style0 from "./assist_person.vue?vue&type=style&index=0&id=1f8d4d80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d4d80",
  null
  
)

export default component.exports